export default {"src":"/_next/static/media/transit-subway.945da74a.svg","height":18,"width":16,"blurWidth":0,"blurHeight":0};